
































































































































































import { useSockets } from '@/app/composable/socket';
import store from '@/app/store';
import Auth from '@/modules/auth/api/auth';
import Keycloak from '@/modules/auth/api/keycloak';
import { useCart } from '@/modules/sharing/composable';
import {
    ArchiveIcon,
    CloudDownloadIcon,
    DocumentSearchIcon,
    LogoutIcon,
    ShoppingBagIcon,
    XIcon,
} from '@vue-hero-icons/outline';
import { computed, defineComponent } from '@vue/composition-api';
import { useFeatureFlags } from '../composable';

export default defineComponent({
    name: 'SideMenu',
    components: {
        DocumentSearchIcon,
        CloudDownloadIcon,
        LogoutIcon,
        ArchiveIcon,
        XIcon,
        ShoppingBagIcon,
    },
    props: {
        mobileMenuOpen: { type: Boolean, default: false },
    },
    setup(props, { root }) {
        const { isEnabled: isFeatureEnabled, areAnyEnabled: areAnyFeaturesEnabled } = useFeatureFlags();
        const { connected, socketConnect, socketDisconnect } = useSockets();
        const user = computed(() => store.state.auth.user);
        const { clearCart } = useCart();
        const logoutIcon = LogoutIcon;
        const sidebarNavigation = computed(() => [
            {
                name: 'Data Collection',
                route: 'data-checkin-jobs',
                icon: CloudDownloadIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'Analytics Workbench',
                route: 'workflows',
                icon: DocumentSearchIcon,
                exact: false,
                visible: isFeatureEnabled('analytics'),
            },
            {
                name: 'Data Assets',
                route: 'assets',
                icon: ArchiveIcon,
                exact: false,
                visible: true,
            },
            {
                name: 'iAMP-Hydro Marketplace',
                route: 'marketplace',
                icon: ShoppingBagIcon,
                exact: false,
                visible: isFeatureEnabled('sharing'),
            },
            {
                name: 'Data Retrieval',
                route: 'retrieval',
                icon: CloudDownloadIcon,
                exact: false,
                visible:
                    areAnyFeaturesEnabled(['retrieve.api', 'retrieve.files', 'retrieve.stream']) &&
                    !!user.value?.organisationId,
            },
        ]);

        const logout = async () => {
            (root as any).$toastr.removeByType('info');
            await Auth.logout();
            socketDisconnect();
            store.commit.notificationEngine.CLEAR_NOTIFICATIONS();
            store.commit.auth.CLEAR_KEYCLOAK_TOKEN();
            store.commit.auth.CLEAR_USER();
            store.commit.sharing.CLEAR_NETWORK();
            clearCart();
            await Keycloak.logout(process.env.VUE_APP_URL);
        };

        return { sidebarNavigation, connected, socketConnect, logout, logoutIcon };
    },
});
